import { apiPromotions } from './apiPromotions'
import { apiPromotionActions } from './apiPromotionActions'
import { apiPromotionRules } from './apiPromotionRules'
import { apiCoupons } from './apiCoupons'

const apiPromo = {
	...apiPromotions,
	...apiPromotionActions,
	...apiPromotionRules,
	...apiCoupons,
}

export { apiPromo }
